import Vue from 'vue'

module.exports = {

    token: null,

    intercept: function(request, next) {

        //get current language from js session
        var language = sessionStorage.getItem('language');
        //fallback language
        if(language == 'undefined'){
            language = 'en';
        }
        request.headers.set('Language', language);

//        var value = "; " + document.cookie;
//		var parts = value.split("; " + 'cid' + "=");
//		if (parts.length == 2){  
//			request.headers.set('cid', parts.pop().split(";").shift());
//		}
		
        next();
    }

};
